import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { ADD_LOCATION, DELETE_LOCATION, EDIT_LOCATION, SET_LOCATION_LIST } from "./actionType";

export const getLocations = (params) => async (dispatch) => {
  try {
    return API.get(`/auctions/locations`, {
      params: {
        page_number: params.page,
        page_size: params.limit,
        search: params.search,
        filter: params.filter,
        sort: params.sort,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_LOCATION_LIST,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const addLocation = (payload) => async (dispatch) => {
  try {
    return API.post(`/auctions/locations`, payload).then((res) => {
      if (res && res.status && res.status === 201) {
        dispatch({
          type: ADD_LOCATION,
          payload: {
            data: res?.data?.data,
          },
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const editLocation =
  ({ id, values }) =>
  async (dispatch) => {
    try {
      return API.put(`/auctions/locations/${id}`, values).then((res) => {
        if (res && res.status && res.status === 200) {
          dispatch({
            type: EDIT_LOCATION,
            payload: {
              data: res?.data?.data,
            },
          });
          toast.success(res?.data?.detail);
          return true;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

export const deleteLocation = (id) => async (dispatch) => {
  try {
    return API.delete(`/auctions/locations/${id}`).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: DELETE_LOCATION,
          payload: {
            deletedId: id,
          },
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};
